import "core-js/modules/es.array.concat";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import { wrapDecorator } from './wrapDecorator';

function LoadingDecorator(target, propertyKey, descriptor, name) {
  var value = descriptor.value;

  descriptor.value = /*#__PURE__*/function () {
    var _loading = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var loadingName,
          _len,
          args,
          _key,
          res,
          _args = arguments;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              loadingName = name || propertyKey + "Loading";
              _context.prev = 1;
              this[loadingName] = true;

              for (_len = _args.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = _args[_key];
              }

              _context.next = 6;
              return value.call.apply(value, [this].concat(args));

            case 6:
              res = _context.sent;
              return _context.abrupt("return", res);

            case 10:
              _context.prev = 10;
              _context.t0 = _context["catch"](1);
              throw _context.t0;

            case 13:
              _context.prev = 13;
              this[loadingName] = false;
              return _context.finish(13);

            case 16:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this, [[1, 10, 13, 16]]);
    }));

    function loading() {
      return _loading.apply(this, arguments);
    }

    return loading;
  }();

  return descriptor;
}

export var Loading = wrapDecorator(LoadingDecorator);